import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/calendar/calendar.js';
      import {CalendarEvent, CalendarType} from '@oicl/openbridge-webcomponents/dist/components/calendar/calendar-utils.js';

      export interface Props {
     type?: CalendarType;
     date?: Date;
     selectedDate?: Date | null;
     events?: CalendarEvent[];
     hasEventList?: boolean;
     hasFooter?: boolean;
     locale?: string | undefined;
     firstDayOfWeek?: number;
     footerLabel?: string;
     footerHref?: string | undefined
   }

      
  
      export type {CalendarEvent, CalendarType} from '@oicl/openbridge-webcomponents/dist/components/calendar/calendar-utils.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcCalendar',
  props: {
    type: {},
    date: {},
    selectedDate: {},
    events: {},
    hasEventList: { type: Boolean },
    hasFooter: { type: Boolean },
    locale: {},
    firstDayOfWeek: {},
    footerLabel: {},
    footerHref: {}
  },
  emits: ["month-change", "date-select", "today-click", "new-event-click", "calendar-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onMonthChange: (event: CustomEvent<{date: Date}>) => emit('month-change', event as CustomEvent<{date: Date}>),
onDateSelect: (event: CustomEvent<{date: Date, events: CalendarEvent[]}>) => emit('date-select', event as CustomEvent<{date: Date, events: CalendarEvent[]}>),
onTodayClick: (event: CustomEvent<void>) => emit('today-click', event as CustomEvent<void>),
onNewEventClick: (event: CustomEvent<void>) => emit('new-event-click', event as CustomEvent<void>),
onCalendarClick: (event: CustomEvent<void>) => emit('calendar-click', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-calendar',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})